// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineInputWrapper_root__HYU1k","required":"MantineInputWrapper_required__KGecu","description":"MantineInputWrapper_description__Dr6oB"};